import React from 'react'

const Partners = () => {
  return <h1>Parceiros</h1>
}

export default Partners